// L'état de la session, dit à l'écran (CDC GBM du 27/10, § 5).
// SE-1 : /auth/me ne répond pas (réseau, délai, redémarrage du serveur) → un avis discret ; la
//        session est gardée et AuthContext réessaie.
// SE-3 : la session ouverte dans la page a expiré → UN avis, et « Se reconnecter », qui ramène à
//        la même page après la connexion. Sur la page de connexion, c'est elle qui le dit.
// Monté une fois, dans le routeur (il lit l'adresse), hors des pages : `.obs2-jetons` porte les
// jetons de couleur, que la racine de l'application n'a pas.
import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../AuthContext'
import { BOUTON_PRINCIPAL, CARTE_COMPTE, LIEN_DISCRET } from '../charte/compte'
import { lienReconnexion } from '../retourConnexion'

export default function AvisSession() {
  const auth = useAuth({ facultatif: true })
  const { pathname, search, hash } = useLocation()
  const navigate = useNavigate()
  const bouton = useRef<HTMLButtonElement>(null)
  const ouvert = !!auth?.sessionExpiree && pathname !== '/login'
  useEffect(() => { if (ouvert) bouton.current?.focus() }, [ouvert])
  if (!auth) return null

  return <>
    {auth.connexionInterrompue && (
      <div role="status" className="obs2-jetons fixed bottom-4 left-1/2 -translate-x-1/2 z-[1000] rounded-(--radius-sm) border border-(--c-border) bg-white px-4 py-2 text-sm text-(--c-text) shadow">
        Connexion au serveur interrompue. Nouvel essai en cours…
      </div>
    )}
    {ouvert && (
      <div className="obs2-jetons fixed inset-0 z-[1001] flex items-center justify-center bg-black/30 px-4">
        <div role="alertdialog" aria-modal="true" aria-labelledby="avis-session-titre"
          aria-describedby="avis-session-texte" className={`w-full max-w-sm ${CARTE_COMPTE} space-y-4 text-center`}>
          <h2 id="avis-session-titre" className="text-lg font-semibold text-(--c-brand)">Votre session a expiré</h2>
          <p id="avis-session-texte" className="text-sm text-(--c-text)">
            Reconnectez-vous pour revenir sur cette page.
          </p>
          <button ref={bouton} type="button" className={BOUTON_PRINCIPAL}
            onClick={() => navigate(lienReconnexion(pathname + search + hash))}>
            Se reconnecter
          </button>
          <button type="button" className={LIEN_DISCRET} onClick={auth.oublierSessionExpiree}>
            Fermer
          </button>
        </div>
      </div>
    )}
  </>
}
